import { getParamsFormObject } from 'utils';
import axiosClient from 'utils/axios';

const endPoint = '/voucher-campaigns';

export default {
  async addVoucherCampaign(payload) {
    const response = await axiosClient.post(endPoint, payload);
    return response.data;
  },

  async getVoucherCampaignDetail(payload) {
    const { id, ...params } = payload;
    const query = getParamsFormObject(params);
    const response = await axiosClient.get(`${endPoint}/${id}${query}`);
    return response.data;
  },

  async addCodeToVoucherCampaign({ id, codes }) {
    const response = await axiosClient.post(`${endPoint}/${id}/vouchers`, {
      codes,
    });
    return response.data;
  },

  async getListVoucherCampaign(payload) {
    const params = getParamsFormObject(payload);
    const path = `${endPoint}${params}`;
    const response = await axiosClient.get(path);
    return response.data;
  },

  async updateVoucherCampaignDetail(payload) {
    const { id } = payload;
    const response = await axiosClient.put(`${endPoint}/${id}`, payload);
    return response.data;
  },

  async deleteVouchersFromCampaign({ id, voucherIds }) {
    const response = await axiosClient.delete(`${endPoint}/${id}/vouchers`, {
      data: { voucherIds },
    });
    return response.data;
  },

  async deleteCampaign(id) {
    const response = await axiosClient.delete(`${endPoint}/${id}`);
    return response.data;
  },
};
